import { useState } from "react";

import { ImportFlowScreens } from "../../utils/constants";
import Steps from "../Steps/Steps";
import {
  DivHeader,
  H1Header,
} from "../UsersManagementAdmin/UsersManagementAdminStyles";
import UsersManagementStepOneForm from "./UsersManagementStepOneForm";
import UsersManagementStepTwoForm from "./UsersManagementStepTwoForm";
import { MainContainer } from "./UsersManagementStyles";

const STEPS = [
  {
    description: "Datos de la empresa",
    screenName: ImportFlowScreens.COMPANY_DATA,
  },
  {
    description: "Datos del usuario",
    screenName: ImportFlowScreens.USER_DATA,
  },
];

const UsersManagementStep = (props) => {
  const {
    toggleModal,
    loadUsers,
    dataUserEdit,
    showModalHide,
    userCompanyMe,
    userProfileMe,
    setMessageTypeEditCreate,
    settitleTypeEditCreate,
    userInfo,
    showProfileTwoShowUser,
  } = props;
  const [screen, setScreen] = useState(ImportFlowScreens.COMPANY_DATA);
  const stepTwoActivate = (step) => {
    setScreen(step);
  };

  const [dataInitialCompany, setDataInitialCompany] = useState({
    ruc: dataUserEdit ? dataUserEdit.company.ruc : userCompanyMe.ruc,
    name: dataUserEdit ? dataUserEdit.company.name : userCompanyMe.name,
    address: dataUserEdit
      ? dataUserEdit.company.address
      : userCompanyMe.address,
    phone_number: dataUserEdit
      ? dataUserEdit.company.phone_number
      : userCompanyMe.phone_number,
    sunarp_number: dataUserEdit
      ? dataUserEdit.company.sunarp_number
      : userCompanyMe.sunarp_number,
    email: dataUserEdit ? dataUserEdit.company.email : userCompanyMe.email,
    contact_name: dataUserEdit
      ? dataUserEdit.company.contact_name
      : userCompanyMe.contact_name,
    contact_phone_number: dataUserEdit
      ? dataUserEdit.company.contact_phone_number
      : userCompanyMe.contact_phone_number,
  });

  const [dataInitialUsers, setDataInitialUsers] = useState({
    user: {
      full_name: dataUserEdit ? dataUserEdit.full_name : "",
      document_type: dataUserEdit ? dataUserEdit.document_type : "dni",
      document_number: dataUserEdit ? dataUserEdit.document_number : "",
      phone_number: dataUserEdit ? dataUserEdit.phone_number : "",
      email: dataUserEdit ? dataUserEdit.email : "",
      job: dataUserEdit ? dataUserEdit.job : "",
      authorization_doc: dataUserEdit
        ? dataUserEdit.role.name
        : userProfileMe.role.name,
    },
    rol: dataUserEdit ? dataUserEdit.role.profile.id : userProfileMe.role.id,
    profile_id: dataUserEdit ? dataUserEdit.role.id : "",
    processes: dataUserEdit
      ? dataUserEdit.processes
      : [
          {
            process_name: "myprocess",
          },
        ],
  });
  const [makeEnabled, setMakeEnabled] = useState(true);
  return (
    <>
      <DivHeader dataUser={dataUserEdit ? true : false}>
        <div className="margin-top-left-position">
          <H1Header>
            {dataUserEdit ? "Editar usuario" : "Crear usuario"}
          </H1Header>
          <div className="font-weight-color">
            {dataUserEdit && dataUserEdit.full_name}
          </div>
        </div>
        <Steps
          currentScreenName={screen}
          updateScreen={setScreen}
          stepsInfo={STEPS}
          makeDisable={makeEnabled}
        />
      </DivHeader>
      <MainContainer>
        {screen === ImportFlowScreens.COMPANY_DATA && (
          <UsersManagementStepOneForm
            dataInitialCompany={dataInitialCompany}
            stepTwoActivate={stepTwoActivate}
            onSuccess={(data) => {
              stepTwoActivate(ImportFlowScreens.USER_DATA);
              setDataInitialCompany(data);
              setMakeEnabled(false);
            }}
            dataUserEdit={dataUserEdit}
          />
        )}
        {screen === ImportFlowScreens.USER_DATA && (
          <UsersManagementStepTwoForm
            loadUsers={loadUsers}
            dataInitialCompany={dataInitialCompany}
            dataInitialUsers={dataInitialUsers}
            toggleModal={toggleModal}
            returnPrevious={(data) => {
              setDataInitialUsers(data);
            }}
            dataUserEdit={dataUserEdit}
            showModalHide={showModalHide}
            userProfileMe={userProfileMe}
            setMessageTypeEditCreate={setMessageTypeEditCreate}
            settitleTypeEditCreate={settitleTypeEditCreate}
            userInfo={userInfo}
            showProfileTwoShowUser={showProfileTwoShowUser}
          />
        )}
      </MainContainer>
    </>
  );
};
export default UsersManagementStep;
